import {
  criteriaGroup,
  isLoyalCriteria,
  didNotPurchaseCategoryOnUnitCriteria,
  purchasedCategoryOnUnitCriteria,
} from '@/components/quick-actions/segmentationGroups.js'

export default [
  {
    name: 'Faturamento',
    tooltip: 'Faturamento dos produtos dessa categoria',
    childrenTabs: [
      {
        name: 'Total',
        metricKey: 'revenue',
        formatter: {
          name: 'currency',
          hasLocaleString: true,
          localeStringDigits: 0,
        },
      },
      {
        name: 'Clube',
        metricKey: 'loyalty_revenue',
        formatter: {
          name: 'currency',
          hasLocaleString: true,
          localeStringDigits: 0,
        },
      },
    ],
  },
  {
    name: 'Clientes',
    tooltip: 'Quantidade de clientes únicos que compraram nas categorias analisadas',
    childrenTabs: [
      {
        name: 'Total',
        metricKey: 'clients',
        formatter: {
          name: 'noop',
          hasLocaleString: true,
          localeStringDigits: 0,
        },
        quickAction: {
          reference: {
            shortDescription: (category) => `Clientes que compraram a categoria ${category.name}`,
            longDescription: (category) => `Clientes que compraram a categoria ${category.name}`, // date
            segmentationGroup: (category, referenceDate, _, unitIds) =>
              criteriaGroup([purchasedCategoryOnUnitCriteria(category.id, referenceDate, unitIds), isLoyalCriteria(true)]),
          },
          current: {
            shortDescription: (category) => `Clientes que compraram a categoria ${category.name}`,
            longDescription: (category) => `Clientes que compraram a categoria ${category.name}`, // date
            segmentationGroup: (category, _, currentDate, unitIds) =>
              criteriaGroup([purchasedCategoryOnUnitCriteria(category.id, currentDate, unitIds), isLoyalCriteria(true)]),
          },
        },
      },
      {
        name: 'Deixaram de Comprar',
        tooltip: 'Clientes que compraram no período referência e não compraram no período atual',
        metricKey: 'clients_purchased_only_on_reference',
        customReferenceGetter: (categoryMetrics) => categoryMetrics?.reference?.clients || 0,
        customCurrentGetter: (categoryMetrics) => categoryMetrics?.reference?.clients_purchased_only_on_period || 0,
        customPercentageCalculator: (referenceValue, currentValue) => (referenceValue ? currentValue / referenceValue : 0),
        customColorValueCalculator: (value) => -value,
        formatter: {
          name: 'noop',
          hasLocaleString: true,
          localeStringDigits: 0,
        },
        cellInformationConfiguration: {
          customHeaders: [
            {
              text: 'Produto',
              value: 'product.name',
              width: '15%',
              sortable: false,
            },
            {
              text: `Clientes que deixaram de comprar`,
              value: 'current_value',
              width: '20%',
            },
          ],
        },
        quickAction: {
          current: {
            shortDescription: (category) => `Clientes que deixaram de comprar a categoria ${category.name}`,
            longDescription: (category) => `Clientes que deixaram de comprar a categoria ${category.name}`, // date
            segmentationGroup: (category, referenceDate, currentDate, unitIds) =>
              criteriaGroup([
                purchasedCategoryOnUnitCriteria(category.id, referenceDate, unitIds),
                didNotPurchaseCategoryOnUnitCriteria(category.id, currentDate, unitIds),
                isLoyalCriteria(true),
              ]),
          },
        },
      },
      {
        name: 'Passaram a Comprar',
        tooltip: 'Clientes que não compraram no período referência e compraram no período atual',
        metricKey: 'clients_purchased_only_on_current',
        customReferenceGetter: (categoryMetrics) => categoryMetrics?.current?.clients || 0,
        customCurrentGetter: (categoryMetrics) => categoryMetrics?.current?.clients_purchased_only_on_period || 0,
        customPercentageCalculator: (referenceValue, currentValue) => (referenceValue ? currentValue / referenceValue : 0),
        formatter: {
          name: 'noop',
          hasLocaleString: true,
          localeStringDigits: 0,
        },
        cellInformationConfiguration: {
          customHeaders: [
            {
              text: 'Produto',
              value: 'product.name',
              width: '15%',
              sortable: false,
            },
            {
              text: `Clientes que passaram a comprar`,
              value: 'current_value',
              width: '20%',
            },
          ],
        },
        quickAction: {
          current: {
            shortDescription: (category) => `Clientes que passaram a comprar a categoria ${category.name}`,
            longDescription: (category) => `Clientes que passaram a comprar a categoria ${category.name}`, // date
            segmentationGroup: (category, referenceDate, currentDate, unitIds) =>
              criteriaGroup([
                purchasedCategoryOnUnitCriteria(category.id, currentDate, unitIds),
                didNotPurchaseCategoryOnUnitCriteria(category.id, referenceDate, unitIds),
                isLoyalCriteria(true),
              ]),
          },
        },
      },
    ],
  },
  {
    name: 'Cupons',
    tooltip: 'Quantidade de cupons com produtos dessa categoria',
    childrenTabs: [
      {
        name: 'Total',
        metricKey: 'coupons',
        formatter: {
          name: 'noop',
          hasLocaleString: true,
          localeStringDigits: 0,
        },
      },
      {
        name: 'Clube',
        metricKey: 'loyalty_coupons',
        formatter: {
          name: 'noop',
          hasLocaleString: true,
          localeStringDigits: 0,
        },
      },
    ],
  },
  {
    name: 'Penetração de cupons',
    tooltip:
      'Quantidade de cupons do periodo versus a quantidade de cupons com produtos da categoria analisada. Mostra a porcentagem de carrinhos onde esse categoria se fez presente',
    childrenTabs: [
      {
        name: 'Total',
        metricKey: 'coupon_penetration',
        formatter: {
          name: 'percent',
          hasLocaleString: true,
          localeStringDigits: 0,
        },
      },
      {
        name: 'Clube',
        metricKey: 'loyalty_coupon_penetration',
        formatter: {
          name: 'percent',
          hasLocaleString: true,
          localeStringDigits: 0,
        },
      },
    ],
  },
  {
    name: 'Ticket Médio',
    tooltip: 'O faturamento dos itens vendidos, dividido pela quantidade de cupons, ambos dessa categoria',
    childrenTabs: [
      {
        name: 'Total',
        metricKey: 'average_ticket',
        formatter: {
          name: 'currency',
          hasLocaleString: true,
          localeStringDigits: 2,
        },
      },
      {
        name: 'Clube',
        metricKey: 'loyalty_average_ticket',
        formatter: {
          name: 'currency',
          hasLocaleString: true,
          localeStringDigits: 2,
        },
      },
    ],
  },
  {
    name: 'Quantidade',
    tooltip: 'Total de itens vendidos nessa categoria. 2 unidades do mesmo SKU são 2 itens.',
    childrenTabs: [
      {
        name: 'Total',
        metricKey: 'quantity',
        formatter: {
          name: 'noop',
          hasLocaleString: true,
          localeStringDigits: 2,
        },
      },
      {
        name: 'Clube',
        metricKey: 'loyalty_quantity',
        formatter: {
          name: 'noop',
          hasLocaleString: true,
          localeStringDigits: 2,
        },
      },
    ],
  },
  {
    name: 'Média de Itens por Cupom',
    tooltip: 'Representa o total de itens dessa categoria dividido pelo total de cupons com essa categoria.',
    childrenTabs: [
      {
        name: 'Total',
        metricKey: 'average_items_in_basket',
        formatter: {
          name: 'noop',
          hasLocaleString: true,
          localeStringDigits: 2,
        },
      },
      {
        name: 'Clube',
        metricKey: 'loyalty_average_items_in_basket',
        formatter: {
          name: 'noop',
          hasLocaleString: true,
          localeStringDigits: 2,
        },
      },
    ],
  },
  {
    name: 'Frequência',
    tooltip: 'Representa a média de cupons, com a categoria, por cliente.',
    childrenTabs: [
      {
        name: 'Clube',
        metricKey: 'loyalty_frequency',
        formatter: {
          name: 'noop',
          hasLocaleString: true,
          localeStringDigits: 2,
        },
      },
    ],
  },
  {
    name: 'Gasto Médio',
    tooltip: 'Representa o gasto médio na categoria, por cliente.',
    childrenTabs: [
      {
        name: 'Clube',
        metricKey: 'loyalty_average_spend',
        formatter: {
          name: 'currency',
          hasLocaleString: true,
          localeStringDigits: 2,
        },
      },
    ],
  },
]
